import { render, staticRenderFns } from "./instractorIcon.vue?vue&type=template&id=d59b2100"
import script from "./instractorIcon.vue?vue&type=script&lang=js"
export * from "./instractorIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports